"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function formatDate(date) {
    var y = date.getFullYear();
    var m = ('0' + (date.getMonth() + 1)).slice(-2);
    var d = ('0' + date.getDate()).slice(-2);
    return y + '-' + m + '-' + d;
}
function getFirstOfMonth() {
    var now = new Date();
    return formatDate(new Date(now.getFullYear(), now.getMonth(), 1));
}
var SchedulingDashboardController = /** @class */ (function () {
    function SchedulingDashboardController(ReportsModel) {
        this.ReportsModel = ReportsModel;
        this.dashboardData = null;
        this.zipBoundaries = [];
        this.loading = false;
        this.error = '';
        this.filters = {
            start_date: getFirstOfMonth(),
            end_date: formatDate(new Date()),
            granularity: 'monthly',
            yoy_type: 'same_period',
            include_instructor_breakdown: true,
            include_location_breakdown: true
        };
        this.onFilterChange = this.handleFilterChange.bind(this);
        this.fetchData();
    }
    SchedulingDashboardController.prototype.handleFilterChange = function (newFilters) {
        this.filters = newFilters;
        this.fetchData();
    };
    SchedulingDashboardController.prototype.fetchData = function () {
        var _this = this;
        this.loading = true;
        this.error = '';
        this.zipBoundaries = [];
        var params = Object.assign({}, this.filters, {
            include_instructor_breakdown: this.filters.include_instructor_breakdown ? 1 : 0,
            include_location_breakdown: this.filters.include_location_breakdown ? 1 : 0
        });
        this.ReportsModel.getSchedulingDashboard(params)
            .then(function (response) {
            _this.dashboardData = response.data;
            _this.loading = false;
            _this.fetchZipBoundaries();
        })
            .catch(function (err) {
            _this.error = 'Failed to load scheduling dashboard data.';
            _this.loading = false;
        });
    };
    SchedulingDashboardController.prototype.fetchZipBoundaries = function () {
        var _this = this;
        var byZip = this.dashboardData &&
            this.dashboardData.location_breakdown &&
            this.dashboardData.location_breakdown.by_zip_code;
        if (!byZip || !byZip.length) {
            return;
        }
        // Only real 5-digit ZIPs map to a boundary; the "Unknown" bucket is skipped.
        var zips = byZip
            .map(function (row) { return String(row.zip_code); })
            .filter(function (zip) { return /^\d{5}$/.test(zip); });
        if (!zips.length) {
            return;
        }
        this.ReportsModel.getZipBoundaries(zips)
            .then(function (response) {
            _this.zipBoundaries = response.data;
        })
            .catch(function () {
            // A boundary failure should not break the rest of the dashboard;
            // the heat map simply renders nothing.
            _this.zipBoundaries = [];
        });
    };
    return SchedulingDashboardController;
}());
SchedulingDashboardController.$inject = ['ReportsModel'];
exports.default = SchedulingDashboardController;
